import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { UserRol } from "./api-interfaces/userrol.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIUserDealerService {
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL = environment.UserDealerURL + 'UserDealer/';
    }

    public get(id:string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        if(id !== null && id !== undefined) {
          return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
        }
        else {
            return this.http.get(this.ApiURL,requestOptions);
        }
    }

    public post(data): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.post<any>(this.ApiURL, data,requestOptions)
  }

  public put(data):Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return this.http.put<any>(this.ApiURL,data,requestOptions) //include id
    }

    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }

}